import React from 'react'

import { EAssetMetaSourceType, IResponseSource } from '../../../interfaces/expert_chats';
import { SVGIcon } from '../../wrappers/SVGIcon';
import { Icons } from '../../../data/Assets';

interface ISourceItemProps {
    source: IResponseSource;
}

const SourceItem = (props: ISourceItemProps) => {
    const { source } = props;

    const getSourceIcon = () => {
        if (source.asset_meta?.source_type === EAssetMetaSourceType.LINK) {
            return Icons.News;
        } else {
            return Icons.Document;
        };
    };

    const onGoToSource = () => {
        window.open(source.asset_meta?.url ?? '', '_blank');
    };

    return (
        <div className='immersion__immigration_help__sources__list__item' onClick={onGoToSource}>
            <div className='immersion__immigration_help__sources__list__item__content'>
                <div className='immersion__immigration_help__sources__list__item__content__title'>
                    <SVGIcon src={getSourceIcon()} color={'primary'} />
                    <p className='immersion__immigration_help__sources__list__item__content__title__text mice'>
                        {source.asset_meta?.name ?? ''}
                    </p>
                </div>
            </div>
        </div>
    )
}

export default SourceItem;